import {
  TRANSACTION_OPTIONS,
  FIAT,
  COUNTRIES,
  OMNI_SUPPORTED_CURRENCIES,
  SYMMETRAL_CURRENCIES,
  IFT_CURRENCIES,
  IFT_OMNI_SUPPORTED_CURRENCIES
} from '@/utils/constants.js'
import { TENANT_PERMISSIONS } from '@/utils/customPermissions.js'

export default {
  computed: {
    tenantName () {
      return process.env.VUE_APP_TENANT_NAME
    },
    tenantTitle () {
      return process.env.VUE_APP_TENANT_TITLE
    },
    tenantVersion () {
      return process.env.VUE_APP_VERSION
    },
    tenantPrimaryColor () {
      return process.env.VUE_APP_TENANT_PRIMARY_COLOR
    },
    exchangeRateData () {
      return this.$store.state.auth.transferDetails
    },
    filteredExchangeRates () {
      // filter to return rates that are enabled
      const enabledExchangeRates = this.exchangeRateData
        ? this.exchangeRateData.filter((item) => item.is_enabled)
        : []
      const tenantExchangeRate = enabledExchangeRates.filter((item) => {
        return (
          this.filteredCurrencyOptions.find(
            (currency) => currency.currency === item.from
          ) &&
          this.filteredCurrencyOptions.find(
            (currency) => currency.currency === item.to
          )
        )
      })
      return tenantExchangeRate
    },
    tenantSecondaryColor () {
      return process.env.VUE_APP_TENANT_SECONDARY_COLOR
    },
    exchangeRateSelectionArray () {
      // removes duplicate .to values
      const uniqueToValues = [
        ...new Set(this.filteredExchangeRates.map((item) => item.to))
      ]
      return uniqueToValues
    },
    tenantIsTorus () {
      return this.tenantName === 'torus'
    },
    tenantIsOval () {
      return this.tenantName === 'oval'
    },
    tenantIsTma () {
      return this.tenantName === 'tma'
    },
    tenantIsSymmetral () {
      return this.tenantName === 'symmetral'
    },
    tenantIsIFT () {
      return this.tenantName === 'ift'
    },
    isOnDevEnvironment () {
      return process.env.NODE_ENV !== 'production'
    },
    paymentLinkCurrencyOptions () {
      let currencyOptions = []
      const businessAccounts =
        this.$store.state.report?.dashboardReports?.balances || []
      const businessSupportedCurrencies = OMNI_SUPPORTED_CURRENCIES.filter(
        (currency) => {
          return businessAccounts.some(
            (account) => account.currency === currency.currency
          )
        }
      )
      switch (true) {
        case this.tenantIsTma:
          currencyOptions = businessSupportedCurrencies.filter(
            (currency) => currency.currency === this.$CURRENCY.NGN
          )
          break
        case this.tenantIsSymmetral:
          // Filter businessSupportedCurrencies based on whether they exist in SYMMETRAL_CURRENCIES
          currencyOptions = businessSupportedCurrencies.filter((currency) =>
            SYMMETRAL_CURRENCIES.some(
              (symmetralCurrency) =>
                symmetralCurrency.currency === currency.currency
            )
          )
          break
        case this.tenantIsIFT:
          currencyOptions = IFT_OMNI_SUPPORTED_CURRENCIES.filter((currency) =>
            IFT_CURRENCIES.some(
              (iftCurrency) => iftCurrency.currency === currency.currency
            )
          )
          break
        case !this.isOnDevEnvironment && !this.tenantIsTma:
          currencyOptions = businessSupportedCurrencies.filter(
            (currency) => currency.currency === this.$CURRENCY.USD
          )
          break
        default:
          currencyOptions = businessSupportedCurrencies
      }
      return currencyOptions
    },
    filteredCurrencyOptions () {
      let currencyOptions = []
      switch (true) {
        case this.tenantIsTorus:
          currencyOptions = COUNTRIES.filter((item) =>
            FIAT.find((el) => el.currency === item.currency)
          )
          break
        case this.tenantIsTma:
          currencyOptions = COUNTRIES.filter(
            (item) => item.currency === this.$CURRENCY.NGN
          )
          break
        case this.tenantIsSymmetral:
          // Filter businessSupportedCurrencies based on whether they exist in SYMMETRAL_CURRENCIES
          currencyOptions = COUNTRIES.filter((currency) =>
            SYMMETRAL_CURRENCIES.some(
              (symmetralCurrency) =>
                symmetralCurrency.currency === currency.currency
            )
          )
          break
        case this.tenantIsIFT:
          currencyOptions = COUNTRIES.filter((currency) =>
            IFT_CURRENCIES.some(
              (iftCurrency) => iftCurrency.currency === currency.currency
            )
          )
          break
        default:
          currencyOptions = COUNTRIES
      }
      return currencyOptions
    },
    filteredTransactionOptions () {
      let transactionOptions = []
      switch (true) {
        case this.tenantIsTorus:
          transactionOptions = TRANSACTION_OPTIONS.filter(
            (option) => option.value !== this.$transactionType.SWAP
          )
          break
        case this.tenantIsTma:
        case this.tenantIsSymmetral:
          transactionOptions = TRANSACTION_OPTIONS.filter(
            (option) => option.value === this.$transactionType.DEPOSIT
          )
          break
        default:
          transactionOptions = TRANSACTION_OPTIONS
      }
      return transactionOptions
    }
  },
  methods: {
    tenantPermission (permissionName) {
      const permission = TENANT_PERMISSIONS.find((p) => p[permissionName])
      return permission && permission[permissionName].includes(this.tenantName)
    }
  }
}
